import React, {Component} from 'react';
import {RouteComponentProps} from 'react-router';
import DashboardLayout, {DashboardTab} from 'layouts/Dashboard';
import {Design} from 'services/entities/designs';
import DesignPreview from 'components/designs/DesignPreview';
import {logPageView} from 'services/analytics';
import './index.scss';
import RouteURLs from 'RouteURLs';
import {loadDesign} from "services/designs";
import {NotFoundError} from "util/errors";

interface PreviewDesignPageProps extends RouteComponentProps<{designCode:string, screenGroupCode:string}> {
}

interface PreviewDesignPageState {
  design: Design|null;
}

export default class PreviewDesignPage extends Component<PreviewDesignPageProps, PreviewDesignPageState> {
  state:PreviewDesignPageState = {
    design: null
  };

  componentDidMount(): void {
    logPageView(RouteURLs.PREVIEW_DESIGN, 'Preview Design');
    loadDesign(this.props.match.params.designCode).then(
      design => this.setState({design: design}),
      ex => {
        if(ex instanceof NotFoundError) {
          this.props.history.replace(RouteURLs.NOT_FOUND);
        }
      }
    );
  }

  render() {
    return <DashboardLayout id="preview-design-page" currentTab={DashboardTab.Designs}>
      { this.state.design && <DesignPreview design={this.state.design} /> }
    </DashboardLayout>;
  }
}